// Cognito User Pool auth using amazon-cognito-identity-js.
// Returns { idToken, signOut } on success.

import {
  CognitoUserPool, CognitoUser, AuthenticationDetails,
} from 'amazon-cognito-identity-js';

let userPool = null;
let currentUser = null;

export function initAuth(config) {
  userPool = new CognitoUserPool({
    UserPoolId: config.userPoolId,
    ClientId:   config.userPoolClientId,
  });
  currentUser = userPool.getCurrentUser();
}

/** Returns existing session if any. Resolves null if not signed in. */
export function existingSession() {
  return new Promise((resolve) => {
    if (!currentUser) return resolve(null);
    currentUser.getSession((err, session) => {
      if (err || !session?.isValid()) return resolve(null);
      resolve({ idToken: session.getIdToken().getJwtToken(), username: currentUser.getUsername() });
    });
  });
}

/**
 * Signs in. On first login, Cognito returns a NEW_PASSWORD_REQUIRED challenge
 * — we surface that to the caller so the UI can prompt for a new password.
 */
export function signIn(username, password) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: username, Pool: userPool });
    const auth = new AuthenticationDetails({ Username: username, Password: password });
    user.authenticateUser(auth, {
      onSuccess: (session) => {
        currentUser = user;
        resolve({ kind: 'session', idToken: session.getIdToken().getJwtToken(), username });
      },
      onFailure: (err) => reject(err),
      newPasswordRequired: () => {
        currentUser = user;
        resolve({ kind: 'new-password-required', user });
      },
    });
  });
}

export function completeNewPassword(user, newPassword) {
  return new Promise((resolve, reject) => {
    user.completeNewPasswordChallenge(newPassword, {}, {
      onSuccess: (session) => {
        currentUser = user;
        resolve({ idToken: session.getIdToken().getJwtToken(), username: user.getUsername() });
      },
      onFailure: (err) => reject(err),
    });
  });
}

export function signOut() {
  if (currentUser) currentUser.signOut();
  currentUser = null;
}
